import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'trim',
    standalone: false
})
export class TrimPipe implements PipeTransform {

  transform(input: string, args?: any): any {
    const data = input?.replace(/ +/g, '-');
    return data;
  }

}
